module.exports = __webpack_public_path__ + "static/sticker-overlay-6d9f2ab869c80cae630c77770b352a26.svg";